import { makeObservable, observable, action } from "mobx";

import { LabelValue } from "../../models/Dashboard/Analytics";
import StockCheckAnalyticsDashboardAPI from "../../api/dashboards/StockCheckAnalyticsDashboardAPI";
import { StockCheckAnalyticsAPIFilters } from "../../models/Dashboard/StockCheckDashboard/StockCheckAnalyticsFilters";

export class StockCheckAnalyticsDashboardStore {
  analyticsAPI: StockCheckAnalyticsDashboardAPI;
  basic_tats: LabelValue[];

  constructor() {
    this.analyticsAPI = new StockCheckAnalyticsDashboardAPI();
    this.basic_tats = [];

    makeObservable(this, {
      basic_tats: observable,
      getStockCheckAnalyticsTats: action,
    });
  }

  getStockCheckAnalyticsTats = async (
    filters: StockCheckAnalyticsAPIFilters
  ) => {
    try {
      const data = (await this.analyticsAPI.getTatsData(
        "/tats",
        filters
      )) as LabelValue[];
      this.basic_tats = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };
}
